import {Component, OnInit, ViewChild, NgZone} from '@angular/core';
import {Router} from '@angular/router';
import {StsHttpService} from '../../../services/sts-http.service';
import {StsUser} from '../../../models/sts-user.model';
import {StsErrorResponse} from '../../../models/sts-error-response';
import {StsNotification} from '../../../models/sts-notification.model';
import {StsNotificationType} from '../../../models/sts-notification-type';
import {StsTenantService} from 'app/services/sts-tenant.service';
import {StsGeneralResult} from '../../../models/sts-general-result.model';
import {StsButtonComponent} from 'app/components/common/sts-button/sts-button.component';
import {StsCaptchaComponent} from '../../common/sts-captcha/sts-captcha.component';
import { StsCaptcha } from 'app/models/sts-captcha.model';

@Component({
  selector: 'app-forgot-account-password',
  templateUrl: './account-forgot-password.component.html',
  styleUrls: ['./account-forgot-password.component.scss']
})
export class AccountForgotPasswordComponent implements OnInit {

  @ViewChild(StsCaptchaComponent) captcha: StsCaptchaComponent;

  stsUser: StsUser = new StsUser();
  public errors: StsNotification[] = [];
  private passwordRecoveryChoices: string[] = [];
  private securityQuestionsActive: boolean = false;
  private securityQuestionsAnswered: boolean = false;

  usernameValid = true;
  uniqueId = true;
  isInTheDecisionFlow = false;
  recoveryMode: string = null;
  userInfo: any = null;

  @ViewChild(StsButtonComponent) submitButton;


  /* ------------------------------------------------------------------------ */

  /* ------------------------------------------------------------------------ */

  constructor(private stsHttp: StsHttpService,
              private router: Router,
              private ngZone: NgZone,
              private tenantService: StsTenantService) {
  }

  ngOnInit() {
    this.tenantService.getTenantSource().subscribe(tenant => {
      if (tenant.passwordRecoveryChoices == null) {
        console.log('Password Recovery Choices is null. Please update Ariel Security Web API');
      }

      this.passwordRecoveryChoices = tenant.passwordRecoveryChoices;

      this.securityQuestionsActive = this.passwordRecoveryChoices
        && this.passwordRecoveryChoices.indexOf("Security Questions") > -1;
    });
  }


  /* ------------------------------------------------------------------------ */

  /* ------------------------------------------------------------------------ */


  handleChoice(r: string) {
    this.errors = [];
    this.recoveryMode = r;
    if (this.recoveryMode === 'email') {
      this.forwardToEmailRecovery();
    } else {
      this.forwardToSecurityQuestions();
    }
  }

  public gotoHome(): void {
    this.router.navigateByUrl('/');
  }


  onSubmit(captcha: StsCaptcha) {
    this.errors = [];

    if (captcha) {
      let rsp = this.captcha.checkForCaptchaError(captcha);
      if (rsp != null) {
        this.errors.push(rsp);
        this.validateFields();
        this.captcha.reset();
        return;
      }
    }

    if (!this.validateFields()) {
      this.captcha.reset();
      return;
    }

    // try { this.ref.detectChanges(); } catch(ex) { console.log(ex); }

    this.submitButton.onSubmit();
    this.errors = [];

    this.stsHttp.post<StsGeneralResult>(
      '/api/global/password/reset?UserName='
      + encodeURIComponent(this.stsUser.userName) + '&pageindex=1&pagesize=10', {
        captcha: captcha,
        userName: encodeURIComponent(this.stsUser.userName)
      }).subscribe(a => {
        let e = new StsNotification();
        if (a.status === 'ok' && a.items.length > 0) {
          e.description = a.message;
          e.level = StsNotificationType.Info;

          this.uniqueId = a.items[0].uniqueId;
          this.userInfo = a.items[0];

          this.securityQuestionsAnswered = this.userInfo.answersProvided;

          // console.log(a, this.uniqueId);

          if (this.uniqueId) {
            let isEmailActive = this.passwordRecoveryChoices.indexOf("Email") > -1;
            let isSecurityQuestionsOptionAvailable =
              this.passwordRecoveryChoices.indexOf("Security Questions") > -1
              && this.securityQuestionsAnswered;

            if (!this.userInfo.isActivated &&
              !this.userInfo.canRequestPasswordRecoveryEmail) {
              this.redirectToHelp();
            } else if (isEmailActive && isSecurityQuestionsOptionAvailable) {
              this.isInTheDecisionFlow = true;
            } else if (isSecurityQuestionsOptionAvailable) {
              this.forwardToSecurityQuestions();
            } else if (isEmailActive) {
              this.forwardToEmailRecovery();
            } else {
              let notification = new StsNotification();
              notification.code = 'sts-no-available-password-recovery-options';
              notification.level = StsNotificationType.Error;
              notification.description = 'No available password recovery options';
              this.errors.push(notification);
            }
            // try { this.ref.detectChanges(); } catch(ex) { console.log(ex); }
          } else {
            this.guardAgainstNoUniqueId();
          }

        } else if (a.status === 'ok' && a.items.length === 0) {
          this.submitButton.onSubmitFinished();
          e.description = 'User ID is invalid.';
          e.code = 'sts-no-users-to-reset';
          e.level = StsNotificationType.Error;
          this.errors.push(e);
          // try { this.ref.detectChanges(); } catch(ex) { console.log(ex); }
          this.captcha.reset();
        } else {
          this.submitButton.onSubmitFinished();
          e.level = StsNotificationType.Error;
          e.description = 'unexpected error';
          e.code = 'sts-generic-error-password-reset';
          this.errors.push(e);
          // try { this.ref.detectChanges(); } catch(ex) { console.log(ex); }
          this.captcha.reset();
        }


      },
      errorRes => {
        this.submitButton.onSubmitFinished();
        errorRes = this.mapError(errorRes);
        this.handleError(errorRes);
        this.captcha.reset();
      });
  }


  /* ------------------------------------------------------------------------ */

  /* ------------------------------------------------------------------------ */

  private redirectToHelp() {
    let url = '/account/help';
    this.router.navigateByUrl(url);
    // try { this.ref.detectChanges(); } catch(ex) { console.log(ex); }
  }

  private forwardToSecurityQuestions() {
    if (this.uniqueId) {
      const url = '/account/forgot-password/questions/' + this.uniqueId;

      // FIX: replacing with ngZone everything works just fine.
      // https://github.com/angular/angular/issues/18254
      this.ngZone.run(() => {
        this.router.navigateByUrl(url);
      });

      // try {
      //   this.ref.detectChanges();
      // } catch (ex) {
      //   console.log(ex);
      // }
    } else {
      this.guardAgainstNoUniqueId();
    }
  }


  private forwardToEmailRecovery() {
    if (this.uniqueId) {
      const url = '/account/forgot-password/email/' + this.uniqueId;

      // FIX: replacing with ngZone everything works just fine.
      // https://stackoverflow.com/questions/35936535/angular-2-ngoninit-not-called
      this.ngZone.run(() => {
        this.router.navigateByUrl(url);
      });
    } else {
      this.guardAgainstNoUniqueId();
    }
  }


  private guardAgainstNoUniqueId() {
    this.submitButton.onSubmitFinished();
    this.errors = [];
    const e = new StsNotification();
    e.level = StsNotificationType.Error;
    e.description = 'unexpected error';
    e.code = 'generic-error';
    this.errors.push(e);
    // try { this.ref.detectChanges(); } catch(ex) { console.log(ex); }
    this.captcha.reset();
  }

  private validateFields() {
    this.usernameValid = !!this.stsUser.userName;
    // try { this.ref.detectChanges(); } catch(ex) { console.log(ex); }
    return this.usernameValid;
  }

  private handleError(data) {
    let err = new StsNotification();
    err.code = data.stsCode || 'sts-reset-pass-message';
    err.description = data.message || data.stsCode || 'Error';
    err.level = StsNotificationType.Error;
    this.errors.push(err);
    this.captcha.reset();
  }

  private mapError(data): StsErrorResponse {
    let response = new StsErrorResponse();
    response.message = data.message;
    response.status = data.status;
    response.stsCode = data['sts-code'];
    return response;
  }

}
